import { initializeApp, getApps, getApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyCacfxaEneoYQVLvEXF9syjGGOarafe9SI',
  authDomain: 'leadbox-a00ae.firebaseapp.com',
  databaseURL: 'https://leadbox-a00ae.firebaseio.com',
  projectId: 'leadbox-a00ae',
  storageBucket: 'leadbox-a00ae.appspot.com',
  messagingSenderId: '120960600796',
  appId: '1:120960600796:web:b3e6703443093c9300c219',
  measurementId: 'G-0HNV6BLKQR',
};

// ✅ Evitar inicializar dos veces
const firebaseApp = getApps().length === 0
  ? initializeApp(firebaseConfig)
  : getApp();

export { firebaseApp };
export const VAPID_KEY = 'BLfWeuuIdNsHrWx-2XIUiXfn_PEWjUMI6oUwLRSerdWw4JmKxE6O22nxcJ6dO60ZPahGMSBlyUTasq1OkgYogdc';
